
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faPhone, faMapMarkerAlt, faSave } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, Container, InputGroup } from '@themesberg/react-bootstrap';
import axiosInstance from "../../api/api";
import { useSelector } from 'react-redux';

export default () => {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: ""
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axiosInstance.get('/api/user/profile');
                if (response.data) {
                    const user = response.data;
                    setFormData({
                        firstName: user.firstName || "",
                        lastName: user.lastName || "",
                        email: user.email || "",
                        phone: user.phone || "",
                        address: user.address || ""
                    });
                }
            } catch (err) {
                console.error("Error fetching user profile:", err);
                // We don't block the UI, just leave fields empty if fetch fails
            }
        };

        fetchUserData();
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setMessage(null);

        try {
            // Using the specified endpoint
            await axiosInstance.put('/api/user/update', formData);
            setMessage("Perfil actualizado correctamente.");
        } catch (err) {
            setError("Error al actualizar el perfil. Verifique los datos.");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="mt-4">
            <Row className="justify-content-center">
                <Col xs={12} xl={8}>
                    <Card border="light" className="bg-white shadow-sm mb-4">
                        <Card.Header>
                            <h5><FontAwesomeIcon icon={faUser} className="me-2" /> Editar Perfil</h5>
                        </Card.Header>
                        <Card.Body>
                            {message && <div className="alert alert-success">{message}</div>}
                            {error && <div className="alert alert-danger">{error}</div>}

                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <Form.Group id="firstName">
                                            <Form.Label>Nombre</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                name="firstName"
                                                value={formData.firstName}
                                                onChange={handleChange}
                                                placeholder="Ingrese su nombre"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Form.Group id="lastName">
                                            <Form.Label>Apellido</Form.Label>
                                            <Form.Control
                                                required
                                                type="text"
                                                name="lastName"
                                                value={formData.lastName}
                                                onChange={handleChange}
                                                placeholder="Ingrese su apellido"
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} className="mb-3">
                                        <Form.Group id="email">
                                            <Form.Label>Email</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><FontAwesomeIcon icon={faEnvelope} /></InputGroup.Text>
                                                <Form.Control
                                                    required
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    placeholder="name@example.com"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} className="mb-3">
                                        <Form.Group id="phone">
                                            <Form.Label>Teléfono</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text><FontAwesomeIcon icon={faPhone} /></InputGroup.Text>
                                                <Form.Control
                                                    type="number"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    placeholder="1234567890"
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Form.Group className="mb-3" id="address">
                                    <Form.Label>Dirección</Form.Label>
                                    <InputGroup>
                                        <InputGroup.Text><FontAwesomeIcon icon={faMapMarkerAlt} /></InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            placeholder="Su dirección completa"
                                        />
                                    </InputGroup>
                                </Form.Group>

                                <div className="mt-3">
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        <FontAwesomeIcon icon={faSave} className="me-2" />
                                        {loading ? "Actualizando..." : "Actualizar Perfil"}
                                    </Button>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};
